<template>
    <v-snackbar v-model="visible" v-if="message">
        {{message}}
        <v-btn icon color="null" @click.native="visible = false">
            <v-icon>close</v-icon>
        </v-btn>
    </v-snackbar>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'Notification',
  data () {
    return {
      message: null,
      visible: false
    }
  },
  computed: {
    ...mapGetters(
      'application', {
        notification: 'notification'
      }
    )
  },
  methods: {
    ...mapActions(
      'application', {
        setNotification: 'setNotification'
      }
    )
  },
  watch: {
    notification (val) {
      if (val) {
        this.message = val
        this.visible = true
        this.setNotification({ notification: null })
      }
    }
  }
}
</script>

<style scoped>

</style>
